var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSequelize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-20 0 296 296",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.013,94.362 L219.013,200.956 L128.437,254.544 L127.618,255.289 L127.618,295.128 L128.437,295.9 L256,222.216 L256,73.684 L254.795,73.389 L218.832,93.495 L219.013,94.362",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.57,201.829 L128.437,254.544 L128.437,295.9 L0,221.925 L0,73.975 L1.318,73.776 L37.177,94.624 L37.57,95.818 L37.57,201.829",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.57,95.818 L0,73.975 L128.146,0 L256,73.684 L219.013,94.362 L128.146,42.521 L37.57,95.818",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878,189.638 L125.894,188.634 L125.894,148.608 L126.878,148.1 L127.117,147.113 L161.432,127.096 L162.482,127.331 L162.482,168.573 L126.878,189.638",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.68,169.858 L90.68,127.035 L91.675,126.986 L126.581,147.3 L126.878,148.1 L126.878,189.638 L90.68,169.858",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.284,105.969 L90.68,127.035 L126.878,148.1 L162.482,127.331 L126.284,105.969",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.57,215.748 L81.587,214.744 L81.587,174.717 L82.57,174.21 L82.81,173.223 L117.124,153.206 L118.174,153.441 L118.174,194.682 L82.57,215.748",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.373,195.968 L46.373,153.144 L47.367,153.095 L82.273,173.41 L82.57,174.21 L82.57,215.748 L46.373,195.968",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.977,132.079 L46.373,153.144 L82.57,174.21 L118.174,153.441 L81.977,132.079",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,216.737 L173.366,215.733 L173.366,175.706 L174.35,175.199 L174.589,174.212 L208.904,154.195 L209.954,154.43 L209.954,195.671 L174.35,216.737",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.152,196.957 L138.152,154.133 L139.147,154.084 L174.053,174.399 L174.35,175.199 L174.35,216.737 L138.152,196.957",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.756,133.068 L138.152,154.133 L174.35,175.199 L209.954,154.43 L173.756,133.068",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.042,242.847 L129.059,241.843 L129.059,201.816 L130.042,201.309 L130.282,200.321 L164.597,180.305 L165.646,180.54 L165.646,221.781 L130.042,242.847",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.845,223.067 L93.845,180.243 L94.839,180.194 L129.746,200.508 L130.042,201.309 L130.042,242.847 L93.845,223.067",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.449,159.177 L93.845,180.243 L130.042,201.309 L165.646,180.54 L129.449,159.177",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.878,132.87 L125.894,131.865 L125.894,91.839 L126.878,91.332 L127.117,90.344 L161.432,70.328 L162.482,70.563 L162.482,111.804 L126.878,132.87",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.68,113.09 L90.68,70.266 L91.675,70.217 L126.581,90.531 L126.878,91.332 L126.878,132.87 L90.68,113.09",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.284,49.2 L90.68,70.266 L126.878,91.332 L162.482,70.563 L126.284,49.2",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.57,158.979 L81.587,157.975 L81.587,117.949 L82.57,117.441 L82.81,116.454 L117.124,96.437 L118.174,96.672 L118.174,137.914 L82.57,158.979",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.373,139.199 L46.373,96.376 L47.367,96.327 L82.273,116.641 L82.57,117.441 L82.57,158.979 L46.373,139.199",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.977,75.31 L46.373,96.376 L82.57,117.441 L118.174,96.672 L81.977,75.31",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,159.968 L173.366,158.964 L173.366,118.938 L174.35,118.43 L174.589,117.443 L208.904,97.426 L209.954,97.661 L209.954,138.903 L174.35,159.968",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.152,140.188 L138.152,97.365 L139.147,97.316 L174.053,117.63 L174.35,118.43 L174.35,159.968 L138.152,140.188",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.756,76.299 L138.152,97.365 L174.35,118.43 L209.954,97.661 L173.756,76.299",
    fill: "#03AFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.042,186.078 L129.059,185.074 L129.059,145.047 L130.042,144.54 L130.282,143.553 L164.597,123.536 L165.646,123.771 L165.646,165.012 L130.042,186.078",
    fill: "#2F406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.845,166.298 L93.845,123.474 L94.839,123.425 L129.746,143.74 L130.042,144.54 L130.042,186.078 L93.845,166.298",
    fill: "#2379BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.449,102.408 L93.845,123.474 L130.042,144.54 L165.646,123.771 L129.449,102.408",
    fill: "#03AFEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequelize);
export default __webpack_public_path__ + "static/media/sequelize.3719f1f11aa4bcfc1210977535863a40.svg";
export { ForwardRef as ReactComponent };